import { render, staticRenderFns } from "./ImmediateMessagePopup.vue?vue&type=template&id=94090dee&scoped=true"
import script from "./ImmediateMessagePopup.vue?vue&type=script&lang=js"
export * from "./ImmediateMessagePopup.vue?vue&type=script&lang=js"
import style0 from "./ImmediateMessagePopup.vue?vue&type=style&index=0&id=94090dee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94090dee",
  null
  
)

export default component.exports